import React from 'react';
import styles from './Nav.module.scss';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import styleVariables from '@Styles/_variables.module.scss';
import { Tabs } from '@Components/Tabs/Tabs';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  drawerPaper: {
    width: `${styleVariables.accountNavWidth}`,
    backgroundColor: `${styleVariables.AFWhiteKnight500}`,
    marginLeft: `${styleVariables.navWidth}`,
    marginTop: `${styleVariables.navbarHeight}`,
    [`@media screen and (max-width: ${styleVariables.screenWidthXs})`]: {
      width: '100vw',
      margin: '0',
    },
  },
});

export const AccountNav = ({
  accountNavItems,
  currentTab,
  setTab,
  navOpen,
  setNavOpen,
}: {
  accountNavItems: Array<{ title: string; slug: string; amount?: number }>;
  currentTab: number;
  setTab: (tabNumber: number) => void;
  navOpen: boolean;
  setNavOpen: (navOpen: boolean) => void;
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const screenXs = useMediaQuery(theme.breakpoints.down('xs'));
  const { t } = useTranslation('account');

  return (
    <Drawer
      variant={!screenXs ? 'permanent' : 'temporary'}
      anchor={'left'}
      classes={{
        paper: classes.drawerPaper,
      }}
      open={navOpen}
      onClose={() => {
        setNavOpen(false);
      }}
      role="navigation"
    >
      <h3 className={styles.navTitle}>{t('account')}</h3>
      <div className={styles.navContainer}>
        <Tabs
          tabs={accountNavItems}
          currentTab={currentTab}
          onTabChange={setTab}
          className={styles.tabs}
          vertical
        />
      </div>
    </Drawer>
  );
};
